import { PortfolioReviewSource } from "creso-core/types";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "web-design-system";
import { REVIEW_SOURCE_OPTIONS } from "../constants";

export function ReviewSourceSelect({
  value,
  onChange,
}: {
  value: PortfolioReviewSource;
  onChange: (value: PortfolioReviewSource) => void;
}) {
  return (
    <Select
      value={value}
      onValueChange={(v) => onChange(v as PortfolioReviewSource)}
    >
      <SelectTrigger className="w-44 bg-background" aria-label="Holdings">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {REVIEW_SOURCE_OPTIONS.map((o) => (
          <SelectItem key={o.value} value={o.value}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
